import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-aa951b4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "animate img-container" }
const _hoisted_2 = { class: "img-container" }
const _hoisted_3 = { class: "animate img-profile" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "profile-text",
  style: {"font-size":"40px"}
}



export default /*#__PURE__*/_defineComponent({
  __name: 'SocialProfileImage',
  props: ['user'],
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (props.user.profile_picture_uri)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: props.user.profile_picture_uri
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(props.user.name.substring(0,1)), 1))
      ])
    ])
  ]))
}
}

})